import { render } from "./SystemSettings.vue?vue&type=template&id=af9ce2ce&scoped=true"
import script from "./SystemSettings.vue?vue&type=script&lang=js"
export * from "./SystemSettings.vue?vue&type=script&lang=js"

import "./SystemSettings.vue?vue&type=style&index=0&id=af9ce2ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af9ce2ce"]])

export default __exports__